declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '1482144676153772'

function loadPixelScript(): Promise<void> {
  return new Promise((resolve) => {
    if (window.fbq) {
      resolve()
      return
    }

    const n: any = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })

    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    try {
      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      script.onload = () => resolve()
      script.onerror = () => resolve()
      document.head.appendChild(script)
    } catch {
      resolve()
    }
  })
}

export function initMetaPixel() {
  loadPixelScript().then(() => {
    if (window.fbq) {
      window.fbq('init', PIXEL_ID)
    }
  })
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  } else {
    loadPixelScript().then(() => {
      if (window.fbq) {
        window.fbq('track', 'PageView')
      }
    })
  }
}

export function trackSubscribedButtonClick() {
  if (window.fbq) {
    window.fbq('trackCustom', 'SubscribedButtonClick', {
      content_name: 'Kit de Loncheras Saludables',
    })
  }
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Kit de Loncheras Saludables',
      content_type: 'product',
      value: 6.36,
      currency: 'USD',
    })
  }
}
